import { Modal } from "../../shared/actions/modal"

const showBookingForbidden = () => {
  const texts = (window.I18n && window.I18n.admin) || {}

  Modal.open({
    title: texts.booking_forbidden_title || "Бронирование недоступно",
    message:
      window.BOOKING_FORBIDDEN_MESSAGE ||
      texts.booking_forbidden_message ||
      "У вашей учётной записи нет прав на создание заявок. Обратитесь к администратору вашей компании.",
    confirmText: texts.booking_forbidden_ok || "Понятно",
    hideCancel: true,
  })
}

window.showBookingForbidden = showBookingForbidden

if (window.jQuery) {
  window.jQuery(document).on("submit", 'form[action$="/bundle/new_optim"]', function (event) {
    if (window.BOOKING_FORBIDDEN === true) {
      event.preventDefault()
      showBookingForbidden()
    }
  })
}
